import { render, staticRenderFns } from "./MobMenuBtn.vue?vue&type=template&id=3dbb8980&scoped=true&"
import script from "./MobMenuBtn.vue?vue&type=script&lang=js&"
export * from "./MobMenuBtn.vue?vue&type=script&lang=js&"
import style0 from "./MobMenuBtn.vue?vue&type=style&index=0&id=3dbb8980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbb8980",
  null
  
)

export default component.exports